import { Box, Grid, MenuItem, Paper, styled, Chip } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import React, { useEffect, useRef, useState } from 'react';

import { ReactComponent as MenuIcon } from '../../../../assets/icons/icon-menu.svg';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Menu, { MenuProps } from '@mui/material/Menu';
import { ReactComponent as CrossCircleReadIcon } from '../../../../assets/icons/icon-cross-circle-red.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/icon-search.svg';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useHistory } from 'react-router-dom';
import { GridColDef } from '@mui/x-data-grid';
import useGetPrivateVehicles, {
  Vehicle,
} from '../../../../hooks/vehicle/useGetPrivateVehicle';
import commons from '../../../../assets/styles/commons';
import ActivityIndicator from '../../../ActivityIndicator';
import ButtonComponent from '../../../atoms/button';
import ItemsPerPageSelect from '../../../atoms/itemsPerPageSelect';
import Pagination from '../../../atoms/pagination';
import Typography from '../../../atoms/typography';
import ModalCustom from '../../../atoms/modalCustom';
import ModalDriver from '../../../../containers/Drivers/components/Modal';
import CustomDataGrid from '../../../atoms/dataGrid';
import useDeletePrivateVehicle from '../../../../hooks/vehicle/useDeletePrivateVehicle';

interface IRowVehiclesData {
  id: string;
  model: string;
  payloadCapacity: number;
  plate: string;
  vehicleType: string;
  createdAt: string;
  crlvDueDate?: string;
}

const StyledMenu = styled((props: MenuProps) => <Menu {...props} />)(
  ({ theme }) => ({
    '& .MuiPaper-root': {
      border: '1px solid #FF7206',
      borderRadius: 4,
      padding: 4,
    },
    '& .MuiList-root': {
      padding: '0px !important',
    },
    '& .MuiList-padding': {
      padding: '0px !important',
    },
  }),
);

const useStyles = makeStyles(() =>
  createStyles({
    chipAtivo: {
      backgroundColor: '#DDFEFD',
      color: '#00D9C5',
      border: '1px solid #00D9C5',
      borderRadius: '8px',
      padding: '0px 8px',
      height: '24px',
      fontSize: 12,
      fontWeight: 'bold',
      fontFamily: commons.fontFamily,
    },
    chipVencido: {
      backgroundColor: '#FFEBEE',
      color: '#D32F2F',
      border: '1px solid #D32F2F',
      borderRadius: '8px',
      padding: '0px 8px',
      height: '24px',
      fontSize: 12,
      fontWeight: 'bold',
      fontFamily: commons.fontFamily,
    },
  }),
);

interface IOptionsCellProps {
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  id: string;
}

const OptionsCell: React.FC<IOptionsCellProps> = ({
  onDelete,
  onEdit,
  id,
}: IOptionsCellProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        aria-label="menu"
      >
        <MenuIcon />
      </IconButton>
      <StyledMenu
        id="basic-menu"
        sx={{
          border: '1px #FF7206 1px',
          borderRadius: 15,
          padding: 10,
        }}
        onClose={handleClose}
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          style={{ display: 'flex', gap: 15 }}
          onClick={() => onEdit(id)}
        >
          {' '}
          <EditOutlinedIcon sx={{ color: '#FF7206' }} />
          Editar
        </MenuItem>
        <MenuItem
          onClick={() => onDelete(id)}
          style={{ display: 'flex', gap: 15 }}
        >
          {' '}
          <CrossCircleReadIcon />
          Excluir
        </MenuItem>
      </StyledMenu>
    </Box>
  );
};

const getColumns = (classes: ReturnType<typeof useStyles>): GridColDef[] => [
  {
    field: 'model',
    flex: 4,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Nome
      </Typography>
    ),
    renderCell: (params: { row: IRowVehiclesData }) => (
      <Typography>{params.row.model}</Typography>
    ),
  },
  {
    field: 'payloadCapacity',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Capacidade
      </Typography>
    ),
    renderCell: (params: { row: IRowVehiclesData }) => (
      <Typography>{params.row.payloadCapacity} kg</Typography>
    ),
  },
  {
    field: 'licensePlate',
    flex: 1.5,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Placa
      </Typography>
    ),
    renderCell: (params: { row: IRowVehiclesData }) => {
      const vehiclePlate = params.row.plate;

      const crlvInfo = params.row.crlvDueDate
        ? `(${params.row.crlvDueDate})`
        : '';
      return (
        <Box display={'flex'} alignItems={'center'}>
          <Typography>{vehiclePlate || 'N/A'}</Typography>
          {params.row.crlvDueDate && (
            <Typography style={{ fontSize: 12, marginLeft: 4 }} color="gray">
              {crlvInfo}
            </Typography>
          )}
        </Box>
      );
    },
  },
  {
    field: 'vehicleType',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Status
      </Typography>
    ),
    renderCell: (params: { row: IRowVehiclesData }) => {
      let statusText = 'Ativo';
      let chipClassName = classes.chipAtivo;

      if (params.row.crlvDueDate) {
        try {
          const [month, year] = params.row.crlvDueDate.split('/');
          const expirationDate = new Date(
            parseInt(year),
            parseInt(month) - 1,
            1,
          );
          const currentDate = new Date();
          currentDate.setDate(1);

          if (expirationDate.getTime() < currentDate.getTime()) {
            statusText = 'Doc. Vencido';
            chipClassName = classes.chipVencido;
          }
        } catch (e) {
          console.error(
            'Erro ao parsear crlvDueDate:',
            params.row.crlvDueDate,
            e,
          );
        }
      }

      return <Chip label={statusText} className={chipClassName} />;
    },
  },
];

const PrivateVehiclesTable: React.FC = () => {
  const classes = useStyles();
  const { execute: getVehicles, loading } = useGetPrivateVehicles();
  const history = useHistory();
  const { execute: executeDeleteVehicle } = useDeletePrivateVehicle();
  const [searchFilterInputValue, setSearchFilterInputValue] = useState('');
  const [vehiclesPerPage, setVehiclesPerPage] = useState(10);
  const [openVehicleDetailsModal, setOpenVehicleDetailsModal] = useState(false);
  const [openConfirmDeletionModal, setOpenConfirmDeletionModal] =
    useState(false);
  const vehicleIdToDelete = useRef('');

  const [rowVehiclesData, setRowVehiclesData] = React.useState<{
    page: number;
    totalRecords: number;
    rows: IRowVehiclesData[];
  }>({ page: 1, totalRecords: 0, rows: [] });

  const [selectedVehicleId, setSelectedVehicleId] = useState<
    string | undefined
  >(undefined);

  const loadVehicles = async (page?: number, searchFilterValue?: string) => {
    const currentPage = page !== undefined ? page : rowVehiclesData.page || 1;

    const privateVehicles = await getVehicles({
      page: currentPage,
      rowsPerPage: vehiclesPerPage,
      searchFilter: searchFilterValue || undefined,
    });

    if (privateVehicles) {
      const formatedRows: IRowVehiclesData[] = privateVehicles.rows.map(
        (row: Vehicle) => {
          const crlvFormatedDueDate = row.crlv?.dueDate || '';

          return {
            id: row.vehicleId,
            model: row.model,
            payloadCapacity: row.payloadCapacity,
            licensePlate: row.plate,
            vehicleType: row.vehicleType,
            createdAt: row.createdAt,
            crlvDueDate: crlvFormatedDueDate,
            plate: row.plate,
          };
        },
      );

      setRowVehiclesData({
        page: privateVehicles.page,
        totalRecords: privateVehicles.totalRecords,
        rows: formatedRows,
      });
      setSelectedVehicleId(undefined);
    }
  };

  const confirmVehicleDeletion = (vehicleId: string) => {
    setOpenConfirmDeletionModal(true);
    vehicleIdToDelete.current = vehicleId;
  };

  const handleDeleteVehicle = () => {
    executeDeleteVehicle(vehicleIdToDelete.current, () => {
      setOpenConfirmDeletionModal(false);
      loadVehicles();
    });
  };

  const handleCloseVehicleDetailsModal = (value: boolean) => {
    if (!value) {
      loadVehicles();
      setOpenVehicleDetailsModal(false);
    } else {
      setOpenVehicleDetailsModal(true);
    }
  };

  const goToUpdateVehicleFormScreen = (vehicleId: string) => {
    history.push(`/home/private-vehicles/edit/${vehicleId}`);
  };

  const goToCreateVehiclesForm = () => {
    history.push('/home/private-vehicles/create');
  };

  useEffect(() => {
    loadVehicles(1);
  }, [vehiclesPerPage]);

  return (
    <Box
      style={{
        border: '1px solid #E4E9F2',
        borderRadius: 4,
        padding: 16,
      }}
      component="div"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Paper
          component="form"
          elevation={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            border: '1px solid #FF7206',
            backgroundColor: '#F7F9FC',
            flex: 1,
            marginRight: 20,
            borderRadius: '8px',
          }}
          onSubmit={event => {
            event.preventDefault();
            loadVehicles(1, searchFilterInputValue);
          }}
        >
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              fontFamily: commons.fontFamily,
            }}
            placeholder="Buscar veículo"
            type="text"
            onChange={event => {
              setSearchFilterInputValue(event.target.value);
            }}
            className="input-filter"
            value={searchFilterInputValue}
            inputProps={{ maxLength: 30 }}
          />
          <IconButton
            type="submit"
            sx={{ p: '10px' }}
            aria-label="Pesquisar"
            onClick={() => {
              loadVehicles(1, searchFilterInputValue);
            }}
          >
            <SearchIcon />
          </IconButton>
        </Paper>

        <ButtonComponent
          theme="primary"
          mb={5}
          onClick={goToCreateVehiclesForm}
        >
          <FontAwesomeIcon icon={solid('plus')} size="sm" color="#fff" /> Novo
          veículo
        </ButtonComponent>
      </Box>
      {loading ? (
        <ActivityIndicator />
      ) : (
        <>
          <CustomDataGrid
            columns={[
              ...getColumns(classes),
              {
                field: 'actions',
                flex: 1,
                editable: false,
                sortable: false,
                renderHeader: () => (
                  <Typography color="gray" fontWeight="700">
                    Ação
                  </Typography>
                ),
                renderCell: params => (
                  <OptionsCell
                    id={String(params.id)}
                    onDelete={confirmVehicleDeletion}
                    onEdit={goToUpdateVehicleFormScreen}
                  />
                ),
              },
            ]}
            rows={rowVehiclesData.rows || []}
            rowCount={rowVehiclesData.totalRecords}
            paginationMode="server"
            pageSize={vehiclesPerPage}
            page={rowVehiclesData.page}
            onPageChange={(newPage: number) => loadVehicles(newPage)}
            onPageSizeChange={(newPageSize: number) =>
              setVehiclesPerPage(newPageSize)
            }
            getRowId={(row: IRowVehiclesData) => row.id}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
          />
          <hr style={{ margin: '16px 0' }} />
        </>
      )}
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <ItemsPerPageSelect
            label={'Mostrar'}
            value={vehiclesPerPage}
            onChange={(value: number) => {
              setVehiclesPerPage(value);
            }}
          />
        </Grid>
        <Grid item>
          <Pagination
            currentPage={rowVehiclesData.page as number}
            totalRecords={rowVehiclesData.totalRecords as number}
            setCurrentPage={(page: number) => {
              loadVehicles(page);
            }}
            rowsPerPage={vehiclesPerPage}
          />
        </Grid>
      </Grid>

      <ModalDriver
        openModal={openVehicleDetailsModal}
        setOpenModal={handleCloseVehicleDetailsModal}
        stepsToValidate={3}
        driverId={selectedVehicleId as string}
      />

      <ModalCustom
        open={openConfirmDeletionModal}
        onCancelClick={() => setOpenConfirmDeletionModal(false)}
        onClickPublish={handleDeleteVehicle}
        ButtonOutlinePrimary="Cancelar"
        ButtonPrimary="Confirmar"
        alignCenter={true}
        hideCloseIcon={true}
        label="Deseja excluir este veículo?"
        boxStyle={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          gap: 2,
        }}
      />
    </Box>
  );
};

export default PrivateVehiclesTable;
